import { MenuItemOption } from '../../../models/nlp/menu/MenuItemOption';
import { MenuItemOptionGroup } from '../../../models/nlp/menu/MenuItemOptionGroup';
import { MenuItemSize } from '../../../models/nlp/menu/MenuItemSize';
import { MenuItemSizeGroup } from '../../../models/nlp/menu/MenuItemSizeGroup';
import MenuItemModel from '../../../models/nlp/menu/MenuItemModel';

export const hasSynonyms = (synonyms?: string[]) => synonyms?.some(synonym => !!synonym?.trim()) === true;

export const optionHasSynonyms = (option: MenuItemOption): boolean => {
    return hasSynonyms(option.additionalSynonyms) || option.optionGroups?.some(optionGroupHasSynonyms) === true;
}

export const optionGroupHasSynonyms = (optionGroup: MenuItemOptionGroup): boolean => {
    return hasSynonyms(optionGroup.additionalSynonyms) || optionGroup.options?.some(optionHasSynonyms) === true;
}

export const sizeHasSynonyms = (size: MenuItemSize): boolean => {
    return hasSynonyms(size.additionalSynonyms) || size.optionGroups?.some(optionGroupHasSynonyms) === true;
}

export const sizeGroupHasSynonyms = (sizeGroup: MenuItemSizeGroup): boolean => {
    return sizeGroup.sizes?.some(sizeHasSynonyms) === true;
}

export const menuItemHasSynonyms = (item: MenuItemModel): boolean => {
    return hasSynonyms(item.additionalSynonyms) ||
        item.optionGroups?.some(optionGroupHasSynonyms) === true ||
        item.sizeGroups?.some(sizeGroupHasSynonyms) === true;
}
